<template>

  <!-- 首页页面 -->
  <div class="home">
    <Header></Header>
    <!-- 背景图 -->
    <div class="Banner_bg">
      <div class="G_search_bx">
        <div class="G_search_title">决策赋能 预见未来</div>
        <div class="searchs">
          <img src="../assets/img/search_icon.png" v-if="ishow==true" class="fd_icon" alt="">
          <input type="text" class="search_ipt" @click="Obtain" @keyup.enter="Go_search" v-model="search"
            :placeholder="placeholder">
          <button class="search_btn" @click="Go_search">搜索</button>
        </div>
        <ul class="tabs">
          <li @click="changes(index)" :class="{active:index == num}" v-for="(item,index) in tabs" :key="index">{{item}}
          </li>
        </ul>
      </div>
    </div>
    <div class="W1200">
      <!-- 最新专利 -->
      <div class="Latest_patent">
        <div class="Latest_patent_title">最新专利</div>
        <div class="Latest_patent_list">
          <div class="Latest_patent_lists" v-for="(item,index) in Patent_List" @click="Go_PatentDetails(item.id)"
            v-if="index<3" :key="index">
            <div class="Latest_patent_lists_img_box">
              <img class="Latest_patent_lists_img" v-if="item.chart_img!=''" :src="item.chart_img" alt="">
              <img class="Latest_patent_lists_img" v-else src="../assets/img/kong_imgs1.png" alt="">
            </div>
            <div class="Latest_patent_lists_bottom">
              <div class="Latest_patent_lists_title">
                {{item.patent_name}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 研报 -->
      <div class="Research_Report">
        <div class="title">
          <div class="title_zh">- 研报 -</div>
          <div class="title_eng">Research Report</div>
        </div>
        <div class="Research_Report_Banner">
          <div class="Research_Report_Banner_left">
            <div class="Research_Report_Banner_left_box" v-for="(item,index) in report_List" v-if="index<3" :key="index"
              @click="Go_ResearchReportDetails(item.id)">
              <div class="Research_Report_Banner_left_title" :class="{banner_active:index == activeIndex}">
                {{item.chinese_title}}</div>
              <div class="over_pad" >
                <div class="Research_Report_Banner_left_content" :class="{banner_actives:index == activeIndex}">{{item.report_profile}}</div>
              </div>
            </div>
          </div>
          <div class="Research_Report_Banner_right">
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item,index) in report_List" v-if="index<3" :key="index"
                  @click="Go_ResearchReportDetails(item.id)">
                  <img style="cursor: pointer;" :src="item.img" alt="">
                </div>
              </div>
              <div class="swiper-pagination"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- 前沿动态 -->
      <div class="Frontier_dynamics">
        <div class="title">
          <div class="title_zh">- 前沿动态 -</div>
          <div class="title_eng">Frontier dynamics</div>
        </div>
        <div class="Frontier_dynamics_list">
          <div class="Frontier_dynamics_lists" v-for="(item,index) in Frontier_List" v-if='index<3' :key="index" @click="Go_InformationDetails(item.id)">
            <div class="Frontier_dynamics_list_img_box">
              <img class="Frontier_dynamics_list_img" v-if="item.img!=''" :src="item.img" alt="">
            </div>
            <div class="Frontier_dynamics_lists_bottom">
              <div class="Frontier_dynamics_lists_title">
                {{item.title}}
              </div>
              <div class="Frontier_dynamics_lists_content" v-html="removeHtmlStyle(item.content)">
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 榜单 -->
      <div class="List">
        <div class="title">
          <div class="title_zh">- 榜单 -</div>
          <div class="title_eng">List</div>
        </div>
        <div class="List_list_box">
          <div class="List_list" v-for="(item,index) in Rank_List" v-if="index<4" :key="index">
            <a :href="item.url" target="_blank">
              <img class="List_list_img" :src="item.img" alt="">
              <div class="List_list_title">{{item.title}}</div>
            </a>
          </div>
        </div>
      </div>

      <!-- - 研究院智库 - -->
      <div class="Research_Institute">
        <div class="title">
          <div class="title_zh">- 研究院智库 -</div>
          <div class="title_eng">Research Institute think tank</div>
        </div>
        <div class="Research_Institute_box">
          <div class="Research_Institute_list" v-for="(item,index) in authors_list" @click="Go_AuthorsHome(item.uid)" :key="index">
            <img v-if="index<=1" class="Research_Institute_list_img" :src="item.headimg" alt="">
            <div v-if="index<=1" class="Research_Institute_list_bottom">
              <div class="Research_Institute_list_title">{{item.organization_name}}</div>
              <div class="Research_Institute_list_content">{{item.organization_desc}}</div>
            </div>
             <img v-if="index>1" class="Research_Institute_list_img" :src="item.headimg" alt="">
            <div v-if="index>1" class="Research_Institute_list_bottom">
              <div class="Research_Institute_list_title">{{item.organization_name}}</div>
              <div class="Research_Institute_list_content">{{item.organization_desc}}</div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Axios from "axios";
import Swiper from "swiper";
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
export default {
   metaInfo(){
    //  首页
     return{
        title: '驱动中国研究院',
        meta: [
            {
                name: 'keywords',
                content: '驱动中国研究院是一家全行业的自媒体平台，提供新闻资讯聚合数据挖掘与引擎算法智能推荐。提供个性化资讯服务，全方位打造商圈自媒体平台，提供连接人与信息的智能服务，打造国内有价值的移动自媒体平台。'
            },
            {
                name: 'description',
                content:' 驱动中国研究院，专利转让，研究报告，科研资讯，驱动中国研究院官网'
            }
        ]
     }     
    },
  name: "Home",
  data() {
    return {
      tabs: ["专利", "研报", "资讯"],
      num: 0,
      activeIndex: 0,
      placeholder: "请输入搜索关键词",
      ishow: true,   
     authors_list:[],
      search: "",
      Patent_List: [], //专利
      report_List: [], //研报
      Frontier_List: [], //前沿动态
      Rank_List: [], //专题
    };
  },
  components: {
    Header,
    Footer,
  },
  methods: {
    // 跳转主页
    Go_AuthorsHome(uid){
       this.$router.push({ name: "AuthorsHome",query: { id: uid }});
    },
    // 研究院智库
      Authors_List(){
         Axios({
        method: "get",
        url: "https://researchadmin.qudong.com/api/zhiku_four",
        params: {},
      }).then((res) => {
        // //console.log(res);
        this.authors_list = res.data.data;
      });
      },
    // 跳转前沿动态详情
    Go_InformationDetails(id){
       this.$router.push({ name: "InformationDetails", query: { id: id } });
    },
    // 跳转研报详情
    Go_ResearchReportDetails(id) {
      this.$router.push({ name: "ResearchReportDetails", query: { id: id } });
    },
    // 跳转专利详情页面
    Go_PatentDetails(id) {
      this.$router.push({ name: "PatentDetails", query: { id: id } });
    },
    // 首页专利列表
    Patent_index() {
      Axios({
        method: "get",
        url: "https://researchadmin.qudong.com/api/patent_index",
        params: {},
      }).then((res) => {
        // //console.log(res);
        this.Patent_List = res.data.data.data;
      });
    },
    // 首页研报列表
    report_index() {
      Axios({
        method: "get",
        url: "https://researchadmin.qudong.com/api/report_index",
        params: {},
      }).then((res) => {
        // //console.log(res);
        this.report_List = res.data.data.data;
      });
    },
    // 首页前沿动态
    consulting() {
      Axios({
        method: "get",
        url: "https://researchadmin.qudong.com/api/zixun_four",
        params: {},
      }).then((res) => {
        // //console.log(res.data.data);
        this.Frontier_List = res.data.data;
      });
    },
    // 首页专题列表
    Rank() {
      Axios({
        method: "get",
        url: "https://weixin.qudong.com/api/author/k_get_list",
        params: {
          limit: 16,
          page: 1,
          catid: 811,
          weight: 10,
          order: 0,
        },
      }).then((res) => {
        // //console.log(res);
        this.Rank_List = res.data.data;
      });
    },
    changes(index) {
      this.num = index;
      // //console.log(index);
      // //console.log(this.num)
    },
    // 点击input事件
    Obtain() {
      this.ishow = false;
      this.placeholder = "";
    },
    // 轮播
    Swiper() {
      var that = this;
      setTimeout(() => {
        var mySwiper = new Swiper(".swiper-container", {
          effect: "fade",
          fadeEffect: {
            crossFade: true,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          loop: true,
          autoplay: true,
          observer: true,
          observeParents: true,
          on: {
            slideChange: function () {
              that.activeIndex = this.realIndex;
            },
          },
        });
        //鼠标覆盖停止自动切换
        mySwiper.el.onmouseover = function () {
          mySwiper.autoplay.stop();
        };

        //鼠标离开开始自动切换
        mySwiper.el.onmouseout = function () {
          mySwiper.autoplay.start();
        };
      }, 300);
    },
    // 去搜索
    Go_search() {
      // //console.log(this.search);
      // //console.log(this.num);
      if (this.search == "" || this.search.split(" ").join("").length == 0) {
        this.$message.warning("请输入关键词");
      }else{
    if (this.num == 0) {
        this.$router.push({
          name: "Searchpant",
          query: { search: this.search },
        });
      } else if (this.num == 1) {
        this.$router.push({
          name: "Searchreport",
          query: { search: this.search },
        });
      } else {
        this.$router.push({
          name: "Searchrefer",
          query: { search: this.search },
        });
      }
}
    
    },
    removeHtmlStyle(html) {
      let rel = /style\s*?=\s*?([‘"])[\s\S]*?\1/g;
      let newHtml = "";
      if (html) {
        newHtml = html.replace(rel, "");
      }
      // 清除类名
      // let relClass = /class\s*?=\s*?([‘"])[\s\S]*?\1/g;
      // let newClassHtml = "";
      // if (newHtml) {
      //   newClassHtml = newHtml.replace(relClass, "");
      // }
      return newHtml;
    },
    adds(){
      this.$store.dispatch('listact');
    }
  },

  mounted() {
    // this.adds();
    this.Swiper();
    this.Patent_index(); //首页专利列表
    this.report_index(); //首页研报列表
    this.consulting(); //首页前沿动态
    this.Rank(); //首页专题列表
    this.Authors_List();      //研究院智库
  },
};
</script>
<style scoped>
.home {
  background: #f5f7f9;
}
.Banner_bg {
  width: 100%;
  height: 480px;
  background-image: url("../assets/img/Index_bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.G_search_bx {
  width: 650px;
  height: 480px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.search_ipt {
  width: 650px;
  height: 48px;
  margin: 0 auto;
  padding-left:15px;
  border: 1px solid #3463db;
}
.tabs {
  display: flex;
}
.tabs li {
  width: 66px;
  height: 35px;
  color: #3463db;
  background: #fff;
  border-radius: 0px 0px 6px 6px;
  text-align: center;
  line-height: 35px;
  cursor: pointer;
}
.active {
  background: #3463db !important;
  color: #fff !important;
}
::-webkit-input-placeholder {
  padding-left: 43px;
}
.searchs {
  position: relative;
}
.fd_icon {
  position: absolute;
  top: 15px;
  left: 15px;
}
.G_search_title {
  font-size: 38px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #ffffff;
  text-align: center;
  margin-top: -99px;
  margin-bottom: 49px;
}
.search_btn {
  position: absolute;
  right: -17px;
  top: 0;
  border: none;
  height: 50px;
  width: 100px;
  background: #3463db;
  color: #ffffff;
  cursor: pointer;
}
.W1200 {
  width: 1200px;
  margin: 0 auto;
}
/* 最新专利 */
.Latest_patent {
  margin-top: -120px;
}
.Latest_patent_title {
  text-align: center;
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #ffffff;
}
.Latest_patent_list {
  margin-top: 20px;
  height: 340px;
  background: #fff;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.Latest_patent_lists {
  width: 380px;
  height: 300px;
  cursor: pointer;
  overflow: hidden;
  transition: background-color 0.5s linear, color 0.5s linear;
  -webkit-transition: background-color 0.5s linear, color 0.5s linear;
  -moz-transition: background-color 0.5s linear, color 0.5s linear;
  -o-transition: background-color 0.5s linear, color 0.5s linear;
}

.Latest_patent_lists:hover {
  background: #3463db;
  color: #fff;
}
.Latest_patent_lists:hover .Latest_patent_lists_title {
  color: #fff;
}
.Latest_patent_lists_img_box {
  width: 380px;
  height: 240px;
  overflow: hidden;
}
.Latest_patent_lists .Latest_patent_lists_img {
  width: 380px;
  height: 240px;
  transition: all 0.6s;
}
.Latest_patent_lists_img:hover {
  width: 380px;
  height: 240px;
  transform: scale(1.4);
}
.Latest_patent_lists_bottom {
  width: 378px;
  height: 60px;
  border-left: 1px solid #e8e8e8;
  border-right: 1px solid #e8e8e8;
  border-bottom: 1px solid #e8e8e8;
  text-align: center;
  line-height: 60px;
}
.Latest_patent_lists .Latest_patent_lists_title {
  padding: 0 20px;
  overflow: hidden;
  color:#333;
  white-space: nowrap;
  font-size:18px;
  font-weight:550;
  text-overflow: ellipsis;
}
/* 研报 */
.Research_Report .title {
  text-align: center;
  margin-top: 50px;
  margin-bottom: 30px;
}
.Research_Report .title .title_zh {
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}
.Research_Report .title .title_eng {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 800;
  color: #999999;
}
.Research_Report_Banner {
  width: 100%;
  height: 480px;
  display: flex;
  background: #fff;
}
.Research_Report_Banner_left {
  width: 480px;
  height: 480px;
}
.Research_Report_Banner_right {
  width: 720px;
  height: 480px;
}

.Research_Report_Banner_left_box {
  padding: 30px 30px 0;
  cursor: pointer;
}
.Research_Report_Banner_left_title {
  font-size: 20px;
  margin-bottom: 10px;
  color: #333333;
  font-family: PingFang SC;
  font-weight: 550;
 overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.Research_Report_Banner_left_content {
  font-size: 16px;
  box-sizing: border-box;
  line-height: 28px;
  color: #666;
  text-align:justify;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.Research_Report_Banner_left_box .over_pad {
  padding-bottom: 20px;
  border-bottom: 1px solid #e8e8e8;
}
.Research_Report_Banner_left_box:nth-child(3) .over_pad {
  border-bottom: 0;
}
.swiper-container {
  width: 720px;
  height: 480px;
}

.swiper-wrapper img {
  width: 720px;
  height: 480px;
  object-fit: cover;
}

/deep/ .swiper-pagination-bullet {
  width: 40px !important;
  height: 8px !important;
  border-radius: 0 !important;
}
.banner_active {
  color: #3463db;
}
.banner_actives{
  color:#333;
}
/* 前沿动态 */
.Frontier_dynamics .title {
  text-align: center;
  margin-top: 50px;
  margin-bottom: 30px;
}
.Frontier_dynamics .title .title_zh {
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}
.Frontier_dynamics .title .title_eng {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 800;
  color: #999999;
}

.Frontier_dynamics_list {
  height: 420px;
  background: #fff;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.Frontier_dynamics_lists {
  width: 380px;
  height: 400px;
  cursor: pointer;
  transition: background-color 0.5s linear, color 0.5s linear;
  -webkit-transition: background-color 0.5s linear, color 0.5s linear;
  -moz-transition: background-color 0.5s linear, color 0.5s linear;
  -o-transition: background-color 0.5s linear, color 0.5s linear;
}
.Frontier_dynamics_list_img_box {
  width: 380px;
  height: 240px;
  overflow: hidden;
}
.Frontier_dynamics_lists .Frontier_dynamics_list_img {
  width: 380px;
  height: 240px;
  transition: all 0.6s;
}
.Frontier_dynamics_list_img:hover {
  transform: scale(1.4);
}
.Frontier_dynamics_lists:hover {
  background: #3463db;
  color: #fff;
}
>>>.Frontier_dynamics_lists:hover .Frontier_dynamics_lists_content p{
  color: #fff;
}
>>>.Frontier_dynamics_lists:hover .Frontier_dynamics_lists_content strong{
  color: #fff;
}
>>>.Frontier_dynamics_lists:hover .Frontier_dynamics_lists_content span{
  color: #fff;
}
>>>.Frontier_dynamics_lists:hover .Frontier_dynamics_lists_content h1{
  color: #fff;
}
>>>.Frontier_dynamics_lists:hover .Frontier_dynamics_lists_content h3{
  color: #fff;
}
>>>.Frontier_dynamics_lists:hover .Frontier_dynamics_lists_content h6{
  color: #fff;
}
.Frontier_dynamics_lists .Latest_patent_lists_img {
  width: 380px;
  height: 240px;
}

.Frontier_dynamics_lists_bottom {
  width: 378px;
  height: 155px;
}
.Frontier_dynamics_lists .Frontier_dynamics_lists_title {
  padding: 20px 20px;
  font-size: 20px;
  font-weight:550;
  height:48px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.Frontier_dynamics_lists .Frontier_dynamics_lists_content {
  padding: 0px 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

}

>>> .Frontier_dynamics_lists_content p {
  text-align:justify;
  display:none;
  font-weight:400;
  color:#333;
  line-height:28px;
}
>>> .Frontier_dynamics_lists_content p:nth-child(1) {
  text-align:justify;
  display:block;
  font-weight:400;
  color:#333;
  line-height:28px;
}
>>> .Frontier_dynamics_lists_content strong {
  text-align:justify;
  font-weight:400;
   color:#333;
}

>>> .Frontier_dynamics_lists_content img {
  display: none;
}

/* 榜单 */

.List .title {
  text-align: center;
  margin-top: 50px;
  margin-bottom: 30px;
}
.List .title .title_zh {
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}
.List .title .title_eng {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 800;
  color: #999999;
}
.List_list {
  cursor: pointer;
}
.List_list_box {
  display: flex;
  justify-content: space-between;
}
.List_list_img {
  width: 288px;
  height: 180px;
}
.List_list_title {
  width: 248px;
  margin: 15px auto;
  text-align: center;
  overflow: hidden;
  font-weight:550;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-height:28px;
  font-weight:540;
  -webkit-box-orient: vertical;
}
/* 研究院智库 */
.Research_Institute .title {
  text-align: center;
  margin-top: 50px;
  margin-bottom: 30px;
}
.Research_Institute .title .title_zh {
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}
.Research_Institute .title .title_eng {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 800;
  color: #999999;
}
.Research_Institute_box {
  display: flex;
  justify-content: space-between;
  background:#fff;
  margin-bottom: 80px;
}
.Research_Institute_list_img {
  width: 176px;
  height: 176px;
  object-fit: cover;
  margin:0 auto;
  padding-top:15px;
}
.Research_Institute_list_bottom {
  padding: 20px;
}
.Research_Institute_list_title {
  text-align: center;
  margin-bottom: 20px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.Research_Institute_list_content {
  font-size: 16px;
  font-family: PingFang SC;
  line-height:28px;
  font-weight: 500;
   margin:0 auto;
  text-align:justify;
  color: #666666;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.Research_Institute_list {
  width: 210px;
  background: #fff;
  cursor: pointer;
}
</style>
